import { Fragment, useState, useEffect } from 'react';
import cx from 'classnames';
import moment from 'moment';
import { useStore } from '../../hooks/store';
import useHttp from '../../hooks/http';
import { setUrlHash } from '../../utils/setUrlHash';
import getApiToken from '../../utils/getApiToken';
import { scrollToElement } from '../../utils';
import Price from '../../utils/prices';
import { CauldronIcon } from '../../utils/icons';
import TicketsSelection from './TicketsSelection';
import Ticket from "../../utils/tickets";
import { selectedDateFormat, timeFormat, selectedDayFormat } from '../../utils/dateFormat';

import {
  Section, CartButton, CartDrawer, Action, Button, EmptyMessage, CloseBtn, RemoveItem
} from '../../styles/styles.js';
import {itemized} from "../../utils/quantities";

const apiToken = getApiToken();

const MiniBasket = ({hash}) => {
  const [state, dispatch] = useStore();
  const { tickets, section, changeType, clientState, email, dateTimeConfirmed, ticketTypeData, postUpdate, initType,
    calendarType, billingIsSet, totalTickets, totalPeople, hasAddons } = state;
  const { isLoading, data, error, sendRequest, clear, endpoint } = useHttp();
  const [cartOpen, setCartOpen] = useState(false);
  const [cartIsEmpty, setCartIsEmpty] = useState(true);
  const [ticketType, setTicketType] = useState(null);

  useEffect(() => {
    if (totalPeople === 0) dispatch('RELEASE_TICKETS');
  }, [totalPeople]);

  useEffect(() => {
    if (changeType || initType) {
      dispatch('SET', {
        changeType: false,
        initType: false
      });

      const s = hash ? hash : section;
      // console.log('ticketTypeData', ticketTypeData);
      // console.log('section', section);
      // console.log('catid', ticketTypeData[s]['catid']);
      // console.log('s', s);
      const obj = {
        '_t': apiToken,
        'id': ticketTypeData[s]['catid'] //clientState.cat
      };
      sendRequest('/wp-json/wbst-booking/v1/resume', 'POST', obj);
    }
  }, [changeType, initType]);

  useEffect(() => {
    // console.log('step', step);
    // console.log('stepped', stepped);
    if (!!postUpdate) {
      // console.log('postUpdate', clientState);
      setCartIsEmpty(false);
      dispatch('SET', {
        postUpdate: false
      });
      const obj = {
        '_t': apiToken,
        'state': clientState
      };
      sendRequest('/wp-json/wbst-booking/v1/update', 'POST', obj);
    }
  }, [postUpdate]);

  useEffect(() => {
    if (!isLoading && !error && data) {
      if (endpoint === 'update' && billingIsSet) {
        dispatch('SET', { fetchPaymentForm: true });
      }
      if (endpoint === 'resume' && data.value.eventTypes.length > 0) {
        console.log('data', data);
        // console.log('calendarType', calendarType);
        if (calendarType === 'booking') {
          const thisFares = data.value.eventTypes[0]['fares'];
          const thisAddons = data.value.eventTypes[0]['addons'];
          const prices = [
            ...thisFares,
            ...thisAddons
          ];
          dispatch('SET', {
            fares: prices,
          });
          if (section === 'studio-tour') {
            const price = new Price(null, prices);
            dispatch('SET', {
              groupPrices: price.group()
            });
          }
        }
        let cS = data.value.clientState;

        const tqObj = sessionStorage.getItem('tq');
        const iqObj = sessionStorage.getItem('iq');
        
        let combinedArr = [];
        if (tqObj) {
          console.log('has tqObj');
          combinedArr = [
            ...JSON.parse(tqObj),
            ...JSON.parse(iqObj)
          ];
        } else if (cS) {
          console.log('has cS');
          console.log('clientState', cS);
          // console.log('tickets', tickets);
          const adultSlug = section === 'deluxe-tour' ? 'deluxe_tour' : section === 'gift-tickets' ? 'adult_gift' : 'adult';
          console.log('adultSlug', adultSlug);
          const adultTix = _.find(cS.tq, ['id', adultSlug]);
          console.log('adultTix', adultTix);
          if (_.every(cS.tq, ['quantity', 0])) {
            console.log('IS ALL ZERO');
            adultTix.quantity = 1;
            dispatch('SET_DEFAULT', section);
          }
          combinedArr = [
            ...cS.tq,
            ...cS.iq || []
          ];
        }
        console.log('combinedArr', combinedArr);
        let ticketObj = new Ticket(combinedArr);
        // if (ticketObj.adultNumber() === 0) {
        //   console.log('ZERO ADULT');
        //   ticketObj = new Ticket(combinedArr, adultSlug, 'add');
        // }

        // console.log('ticketObj adults', ticketObj.adultNumber());
        // console.log('ticketObj.singleCount()', ticketObj.singleCount());
        dispatch('SET', {
          showLoader: false,
          clientStateReady: true,
          clientState: cS,
          availPackages: ticketObj.singleCount(),
          hidePackageAddons: ticketObj.singleCount() === 0
        });
        dispatch('SET_MESSAGE');
        if (cS.evid) {
          const rID = cS.evid.split('-');
          setTicketType(_.findKey(ticketTypeData, {'rid': rID[0]}));
          dispatch('SET', {
            dateTimeConfirmed: true,
            buttonDisabled: false
          });
        }
        
        if (calendarType === 'booking') {
          if (cS && cS.evid) {
            // console.log('has evid');
            // console.log('dayFormat', dayFormat);
            dispatch('SET', {
              step: !!(cS.delivery.email && hasAddons) ? 3 : 2,
              stepped: !!(cS.delivery.email && hasAddons) ? 3 : 2,
              buttonDisabled: false,
              postUpdate: true,
              timerActive: true,
              firstName: cS.delivery.firstName,
              lastName: cS.delivery.lastName,
              email: cS.delivery.email,
              phone: cS.delivery.phone,
              affiliate: cS.delivery.affiliate,
              deliveryAddress1: cS.delivery.address1, 
              deliveryAddress2: cS.delivery.address2, 
              deliveryCity: cS.delivery.city, 
              deliveryState: cS.delivery.state, 
              deliveryPostal: cS.delivery.postal, 
              deliveryCountry: cS.delivery.country,
              address1: cS.billing.billingAddress1, 
              address2: cS.billing.billingAddress2, 
              city: cS.billing.billingCity, 
              geostate: cS.billing.billingState, 
              postal: cS.billing.billingPostal, 
              country: cS.billing.billingCountry,
              dateContext: moment.utc(cS.evtime),
              selectedDay: selectedDayFormat(cS.evtime),
              selectedDate: selectedDateFormat(cS.evtime),
              selectedDateTime: cS.evtime,
              selectedTime: timeFormat(cS.evtime),
              selectedEvent: cS.evid,
              dateTimeConfirmed: true,
              checkParking: true
            });
          }
        } else if (calendarType === 'redemption') {
          // console.log('cS', cS);
          if (cS && cS.orderID) {
            const combinedArr = [
              ...cS.tq,
              ...cS.iq
            ];
            // console.log('combinedArr', combinedArr);
            const ticketObj = new Ticket(combinedArr);
            const family1Num = cS.tq.find(t => t.id === 'family_2_2').quantity;
            const family2Num = cS.tq.find(t => t.id === 'family_1_3').quantity;
            dispatch('SET', {
              step: 2,
              stepped: 2,
              fetchMonth: true,
              orderID: cS.orderID,
              firstName: cS.delivery.firstName,
              lastName: cS.delivery.lastName,
              email: cS.delivery.email,
              adultTickets: ticketObj.adultNumber(),
              childTickets: ticketObj.childNumber(),
              isfam_2_2: family1Num > 0,
              isfam_1_3: family2Num > 0,
              totalPeople: ticketObj.totalPeople(),
              totalTickets: ticketObj.totalTickets()
            });
          }
        }

      }
    }
  }, [data]);

  useEffect(() => {
    if (!isLoading && error) {
      if (error.status === 400 && error.data.data.params.hasOwnProperty('_t')) {
        dispatch('SET', {
          showSessionMessage: true,
          timerActive: false
        });
        // var alert = confirm('Your session expired. Please refresh the page.');
        // if(alert || !alert){
        //   window.location.reload();
        // }
      }
      if (error.status === 500) {
        handleUpdateError();
      }
      console.log(error);
    }
  }, [error]);

  const handleUpdateError = (message) => {
    console.log('handleUpdateError', message);
    // dispatch('SET', {
    //   showLoader: false,
    //   step: 1
    // });
    // if (message) setFormSubmissionError(message);
  }

  const changeOrder = () => {
    if (!window.location.pathname.includes('buy-tickets')) {
      window.location.href = '/buy-tickets/#' + ticketType;
    } else {
      goToBooking();
    }
  }
  const goToBooking = () => {
    dispatch('SET', {
      showBooking: true
    });
    toggleCart();
    dispatch('RESET_MESSAGES');
    setUrlHash(section);
    scrollToElement('booking');
  }
  const checkout = () => {
    if (dateTimeConfirmed) dispatch('SET', { step: 3 });
  }
  const toggleCart = () => {
    setCartOpen(!cartOpen);
  }

  return (
    <Fragment>
      <CartButton onClick={toggleCart} className={cx({ 'empty': cartIsEmpty })}>
        {!cartIsEmpty && <span className="numItems">{totalTickets}</span>}
        <CauldronIcon/>
      </CartButton>
      <CartDrawer className={cx({ 'visible': cartOpen })}>
        <CloseBtn className="close" onClick={toggleCart}><span>Close</span> <i className="fa fa-times"></i></CloseBtn>
        <Section className="nopad">
          <h4 className="mb-3">Your Basket</h4>
          <TicketsSelection theme="dark" />
          <Action className="right">
            <Button onClick={changeOrder}><i className="fas fa-edit"></i> Change</Button>
            <Button onClick={checkout} className={cx({ 'disabled': !dateTimeConfirmed })}><i className="fas fa-check"></i> Checkout</Button>
          </Action>
        </Section>
      </CartDrawer>
    </Fragment>
  );
}
export default MiniBasket;
